import classNames from "classnames";
import { FormikHandlers } from "formik";
import React, { ChangeEvent, Fragment, SyntheticEvent } from "react";

import {
    BaseField,
    BaseProps,
} from "@components/Form/FormFields/Base/base.component";

import "./textAreaField.scss";

type TextAreaFieldProps = BaseProps & {
    innerRef?: any;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    maxLength?: number;
    rows?: number;
};

const TextAreaField = ({
    label,
    name,
    microCopy,
    required,
    hideLabel,
    optionalIndication,
    innerRef,
    className,
    placeholder,
    validationRule,
    maxLength,
    disabled,
    rows = 3,
    tooltip,
}: TextAreaFieldProps) => {
    const handleChange = (
        e: ChangeEvent<HTMLTextAreaElement>,
        onChangeCB: FormikHandlers["handleChange"],
    ) => {
        const { value = "" } = e.currentTarget;
        let parsedValue = value;

        // als maxlength voorbij is, geen input meer toelaten
        const hasPassedMaxLength =
            maxLength &&
            maxLength > 0 &&
            parsedValue.toString().length > maxLength;
        if (hasPassedMaxLength) {
            e.preventDefault();
            return;
        }

        // Use this for large numbers eg. gift card
        // Gift card number exceeds MAX_SAFE_INTEGER, 29008389902072765 becomes 29008389902072764
        // formik parses the value to an integer as default when field type is set to number

        onChangeCB && onChangeCB(e);
    };

    return (
        <BaseField
            label={label}
            name={name}
            microCopy={microCopy}
            required={required}
            hideLabel={hideLabel}
            optionalIndication={optionalIndication}
            validationRule={validationRule}
            tooltip={tooltip}
        >
            {({ field, meta }) => {
                const invalid = meta.touched && !!meta.error;
                const valid = meta.touched && !meta.error;

                const classes = classNames(
                    className,
                    invalid && "is-invalid",
                    valid && "is-valid",
                    "form-control",
                );

                return (
                    <Fragment>
                        <textarea
                            {...field}
                            ref={innerRef}
                            className={classes}
                            id={name}
                            placeholder={placeholder ? placeholder : ""}
                            aria-invalid={invalid}
                            onChange={e => handleChange(e, field.onChange)}
                            disabled={disabled}
                            rows={rows}
                        />
                        {maxLength && (
                            <small className="text-area-field__count">{`${
                                field.value?.length || 0
                            }/${maxLength}`}</small>
                        )}
                    </Fragment>
                );
            }}
        </BaseField>
    );
};

export { TextAreaField };
